module.exports = __webpack_public_path__ + "img/levelvertPitch.f1285d8a.svg";